module.exports = __webpack_public_path__ + "static/media/arrow-up-down.173b201a.svg";